<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <div class="tinto-filters">
      <CRow>
        <CCol md="5">
          <input class="form-control" v-model="filtros.termo" placeholder="Buscar por nome ou código..." @keyup.enter="load()" />
        </CCol>
        <CCol md="3">
          <select class="form-control" v-model="filtros.fabricanteId" @change="load()">
            <option value="">Todos os fabricantes</option>
            <option v-for="(n,id) in fabricantes" :key="id" :value="id">{{ n }}</option>
          </select>
        </CCol>
        <CCol md="2">
          <select class="form-control" v-model="filtros.ativo" @change="load()">
            <option value="">Todos</option>
            <option value="1">Ativos</option>
            <option value="0">Inativos</option>
          </select>
        </CCol>
        <CCol md="2">
          <button class="button button-primary" @click="load()">Buscar</button>
        </CCol>
      </CRow>
    </div>

    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:50px">ID</th>
          <th style="width:280px" class="tinto-sortable" :class="{'is-active': sort.by==='nome'}" @click="sortBy('nome')">
            Nome<fa-icon :icon="sort.by==='nome' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:140px" class="tinto-sortable" :class="{'is-active': sort.by==='id_externo'}" @click="sortBy('id_externo')">
            Código Externo<fa-icon :icon="sort.by==='id_externo' ? (sort.dir==='asc' ? 'arrow-up' : 'arrow-down') : 'arrow-down'" class="sort-icon" />
          </th>
          <th style="width:110px">Fabricante</th>
          <th style="width:60px;text-align:center">Hex</th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0"><td colspan="5" class="tinto-table__empty">Nenhuma cor encontrada</td></tr>
          <tr v-for="r in items" :key="r.id">
            <td>{{ r.id }}</td>
            <td class="tinto-table__primary">
              <span v-if="r.nome">{{ r.nome }}</span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td>{{ r.cod }}</td>
            <td>{{ r.fabricanteNome }}</td>
            <td style="text-align:center">
              <span
                v-if="r.hexa"
                class="tinto-cor-swatch"
                :style="{ background: r.hexa }"
                :title="r.hexa"
              ></span>
              <span v-else class="tinto-table__muted">—</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import listagemMixin from "./listagemMixin";

export default {
  name: "tintometrico-cor",
  components: { Loading },
  mixins: [listagemMixin],
  props: ['fabricantes'],

  data() {
    return {
      listagemEndpoint: '/admin/tintometrico/cor',
      sort: { by: 'nome', dir: 'asc' },
      filtros: { termo: '', fabricanteId: '', ativo: '' },
    };
  },

  methods: {
    appendFiltros(params) {
      if (this.filtros.fabricanteId) params.append('fabricante_id', this.filtros.fabricanteId);
      if (this.filtros.ativo !== '') params.append('ativo', this.filtros.ativo);
      if (this.filtros.termo) params.append('q', this.filtros.termo);
    },
  },
};
</script>
